import { useState } from 'react';

import { ActionBar, DownloadIcon } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../../translations';
import { CSVDownloader } from '../../csv/CSVDownloader';

import { StatisticsPreviewActionBarOrder } from './StatisticsPreviewActionBar';

type DownloadAsCsvLinkProps = {
   readonly statisticsId: number;
};

export const DownloadAsCsvLink = (props: DownloadAsCsvLinkProps): JSX.Element => {
   const [downloading, setDownloading] = useState(false);

   return (
      <>
         <CSVDownloader
            statisticsId={props.statisticsId}
            downloading={downloading}
            onDownloaded={() => setDownloading(false)}
         />
         <ActionBar.OptionalLink
            testId='downloadAsCsv'
            icon={<DownloadIcon testId={'downloadIcon'} />}
            name={'downloadAsCsv'}
            label={statisticsTranslationKeys.preview.downloadAsCsv}
            order={StatisticsPreviewActionBarOrder.DownloadAsCsv}
            onClick={() => setDownloading(true)}
         />
      </>
   );
};
